import React, { useEffect, useState } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import LightModeIcon from '@mui/icons-material/LightMode';
import List from '@mui/material/List';
import ListIcon from '@mui/icons-material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import HomeIcon from '@mui/icons-material/Home';

// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';

const drawerWidth = 240;
const navItems = [['Home', 'home'], ['Profile', 'profile'], ['Projects', 'projects'], ['Affiliations', 'affiliations'], ['Volunteering', 'volunteering'], ['Publications', 'papers'], ['Contact', 'contact']];

function Navigation({parentToChild, modeChange}: any) {

  const {mode} = parentToChild;
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);
  const [scrolled, setScrolled] = useState<boolean>(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById("navigation");
      if (navbar) {
        const scrolled = window.scrollY > navbar.clientHeight;
        setScrolled(scrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (section: string) => {
    const el = document.getElementById(section);
    if (el) {
      const nav = document.getElementById("navigation");
      const offset = nav ? nav.clientHeight : 64;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const open = Boolean(anchorEl);
  // const hoverTimeout = React.useRef<NodeJS.Timeout | null>(null);

  // const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  //   if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleMouseLeave = () => {
  //   hoverTimeout.current = setTimeout(() => {
  //     setAnchorEl(null);
  //   }, 150);
  // };

  // const handleSubSectionClick = (subId: string) => {
  //   setAnchorEl(null);
  //   scrollToSection(subId);
  // };

  const drawer = (
    <Box className="navigation-bar-responsive" onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <p className="mobile-menu-top"><ListIcon/>Menu</p>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item[0]} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }} onClick={() => scrollToSection(item[1])}>
              <ListItemText primary={item[0]} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar component="nav" id="navigation" className={`navbar-fixed-top${scrolled ? ' scrolled' : ''}`}>
        <Toolbar className='navigation-bar'>
          <IconButton 
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' }}}
          >
            <MenuIcon />
          </IconButton>
          {mode === 'dark' ? (
            <LightModeIcon sx={{ fontSize: '2rem', '&:hover': {color: '#7646be', cursor: 'pointer'}}} onClick={() => modeChange()}/>
          ) : (
            <DarkModeIcon sx={{ fontSize: '2rem' }} onClick={() => modeChange()}/>
          )}
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item) => (
              <Button key={item[0]} onClick={() => scrollToSection(item[1])} sx={{ color: '#fff' }}>
                {item[0]}
              </Button>

              // Uncomment below to enable dropdown on hover for "Projects"
              // item[0] === 'Projects' ? (
              //   <Box
              //     key={item[0]}
              //     sx={{ display: 'inline-block' }}
              //     onMouseEnter={handleMouseEnter}
              //     onMouseLeave={handleMouseLeave}
              //   >
              //     <Button
              //       sx={{ color: '#fff' }}
              //       onClick={() => scrollToSection('projects')}
              //       aria-controls={open ? 'projects-menu' : undefined}
              //       aria-haspopup="true"
              //       aria-expanded={open ? 'true' : undefined}
              //     >
              //       {item[0]}
              //     </Button>
              //     <Menu
              //       id="projects-menu"
              //       anchorEl={anchorEl}
              //       open={open}
              //       onClose={() => setAnchorEl(null)}
              //       MenuListProps={{
              //         onMouseEnter: () => {
              //           if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
              //         },
              //         onMouseLeave: handleMouseLeave,
              //       }}
              //       anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              //       transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              //     >
              //       <MenuItem onClick={() => handleSubSectionClick('projects-web')}>Web</MenuItem>
              //       <MenuItem onClick={() => handleSubSectionClick('projects-mobile')}>Mobile</MenuItem>
              //       <MenuItem onClick={() => handleSubSectionClick('projects-ai')}>AI</MenuItem>
              //     </Menu>
              //   </Box>
              // ) : null
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

export default Navigation;